/**
 * Store: Quick-add store
 * -----------------------------------------------------------------------------
 * Store to hold all quick add product and variant state.
 */
export default {
  namespaced: true,

  state: () => ({
    product: null,
    uid: '',
  }),

  mutations: {

    /**
     * Set product to use.
     * @param {object} product - Product object to use.
     */
    SET_PRODUCT(state, product) {
      state.product = product
    },

    /**
     * Set current quick add trigger UID
     * @param {String} uid - Quick add trigger's UID
     */
    SET_UID(state, uid) {
      state.uid = uid
    },
  },

  actions: {

    /**
     * Commit quick add product state.
     * @param {object} product - Product object to use.
     */
    setProduct({ commit }, product) {
      commit('SET_PRODUCT', product)
    },

    /**
     * Commit ID of the quick add trigger
     * @param {String} uid - Unique ID from the quick add drawer
     */
    setUID({ commit }, uid) {
      commit('SET_UID', uid)
    },
  },
}
